export default __webpack_public_path__ + "static/media/uz.27590f4a.png";